import React from 'react';
import { HolographicButton } from '../components/HolographicButton';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
export function Hero() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('value-stack');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-0 pb-16 md:pb-24 overflow-hidden bg-surface" data-id="element-112">
      {/* Super-headline Banner */}
      <div className="bg-primary text-white w-full py-3 px-4 text-center" data-id="element-113">
        <p className="font-heading font-bold text-sm md:text-base tracking-wide uppercase" data-id="element-114">
          RECUPERA +10 HORAS DE TU SEMANA
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20" data-id="element-115">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-116">
          {/* Content Column */}
          <div className="flex flex-col z-10 order-1 md:order-1" data-id="element-117">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-graphite leading-tight mb-6" data-id="element-118">
              De 'visto' a ventas: Domina tus DMs con agentes de IA.
            </h1>

            {/* Mobile Image - Shows only on mobile, below the headline */}
            <div className="block md:hidden mb-8" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/v65Jwc7pyhoopCooiMVoTR/Mockup_principal.png" alt="Kit de Supervivencia: Ventas por DM - Guía práctica para cerrar negocios" className="w-full max-w-sm mx-auto rounded-2xl shadow-2xl" data-id="element-120" />
            </div>

            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-121">
              El sistema de{' '}
              <strong className="text-graphite" data-id="element-122">IA Consultiva</strong> para
              micro-emprendedoras que quieren cerrar ventas de{' '}
              <strong className="text-graphite" data-id="element-123">$10, $50 o $100 USD</strong> sin
              sonar desesperadas, sin perseguir clientes y sin pasar 8 horas
              pegadas al celular.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-124">
              {['Respuestas listas para NO volver a quedarte en visto', 'Cierra sin presionar: guiones que guían al pago', 'Funciona en WhatsApp e Instagram con ChatGPT (gratis)'].map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-125">
                  <CheckCircle2 className="w-6 h-6 text-success flex-shrink-0 mt-0.5" data-id="element-126" />
                  <span className="text-gray-700 font-medium text-lg" data-id="element-127">
                    {bullet}
                  </span>
                </li>)}
            </ul>

            <div className="flex flex-col items-start gap-4" data-id="element-128">
              <HolographicButton variant="primary" size="xl" onClick={scrollToOffer} className="w-full md:w-auto animate-pulse-glow" data-id="element-129">
                Quiero aprender ya
              </HolographicButton>

              <p className="text-sm text-gray-500 font-medium text-center w-full md:w-auto" data-id="element-130">
                Pago único • Acceso de por vida • Entrega inmediata por email
              </p>

              <div className="flex items-center gap-4 mt-2 text-sm text-gray-400" data-id="element-131">
                <div className="flex items-center gap-1" data-id="element-132">
                  <ShieldCheck className="w-4 h-4" data-id="element-133" />
                  <span data-id="element-134">Pago seguro SSL</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-135">
                  <img src="https://cdn.magicpatterns.com/uploads/59p5MRYa4zpgtNfxhE81DX/logo_pse.png" alt="PSE" className="h-6 w-auto object-contain" data-id="element-136" />
                  <img src="https://cdn.magicpatterns.com/uploads/bS7oX2gkbEbu3QXoYJmUU9/logo_nequi.png" alt="Nequi" className="h-5 w-auto object-contain" data-id="element-137" />
                </div>
              </div>
            </div>
          </div>

          {/* Image Column - Desktop only */}
          <div className="relative z-10 order-2 md:order-2 hidden md:flex justify-center" data-id="element-138">
            <div className="relative w-full max-w-md" data-id="element-139">
              <img src="https://cdn.magicpatterns.com/uploads/v65Jwc7pyhoopCooiMVoTR/Mockup_principal.png" alt="Kit de Supervivencia: Ventas por DM - Guía práctica para cerrar negocios" className="w-full h-auto rounded-2xl shadow-2xl transform transition-transform duration-500 hover:scale-105" data-id="element-140" />
              {/* Decorative background elements */}
              <div className="absolute -top-8 -right-8 w-64 h-64 bg-accent opacity-20 rounded-full blur-3xl -z-10" data-id="element-141"></div>
              <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-primary opacity-20 rounded-full blur-3xl -z-10" data-id="element-142"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}